import { render, staticRenderFns } from "./AlertColorBorder.vue?vue&type=template&id=6431baad&"
import script from "./AlertColorBorder.vue?vue&type=script&lang=js&"
export * from "./AlertColorBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAlert,VListItemSubtitle})
